import { string } from 'prop-types'
import { useEffect } from 'react'

import expander from 'views/assets/scripts/expander'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import NowShippingModalContent from 'views/components/organisms/NowShippingModal/NowShippingModalContent'

const NowShippingModalContainer = ({ searchResultUpid }) => {
  useEffect(() => {
    expander()
    floatingLabel()
  }, [])

  return <NowShippingModalContent productUpid={searchResultUpid} />
}

NowShippingModalContainer.propTypes = {
  searchResultUpid: string,
}

NowShippingModalContainer.defaultProps = {
  searchResultUpid: '',
}

export default NowShippingModalContainer
